import { Component, effect, inject, Signal, signal, viewChild, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { ButtonComponent } from '../../components/button/button.component';
import TYPES from '../../constants/types';
import { TranslatePipe } from '@ngx-translate/core';
import { HeaderComponent } from "../../components/header/header.component";
import { StepperComponent } from '../../components/stepper/stepper.component';
import { Router } from '@angular/router';
import { LogService } from '../../services/log.service';
import { Log } from '../../models/log';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-feeling',
  imports: [
    MatSliderModule,
    FormsModule,
    ButtonComponent,
    TranslatePipe,
    HeaderComponent,
    StepperComponent
],
  templateUrl: './mood.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mood.component.scss'
})
export class MoodComponent {

  BUTTON_TYPES:any;
  moods:any;

  value: WritableSignal<number> = signal<number>(1);
  step: Signal<StepperComponent | undefined> = viewChild<StepperComponent>('stepper');
  
  private authService: AuthService = inject(AUTH_SERVICE);

  constructor(
    private router: Router,
    private logService: LogService<Log>
  ){
    this.BUTTON_TYPES = TYPES.UI.BUTTON;
    this.moods = TYPES.APPLICATION.MOODS;

    effect(() => {
      this.step()?.steps()[0].nativeElement.classList.add('active');
    });

    if(this.logService.log()){
      let index = 1;
      for(const mood of this.moods){
        if(this.logService.log().mood === mood.label){
          this.value.set(index);
          break;
        }
        index++;
      }
    }
  }

  next(){
    this.logService.log.update( 
      (current) => {
        return {
          ...current,
          mood: this.moods[this.value()-1].label,
          user_id: this.authService.user()?.id || null
        }
      }
    );
    this.router.navigate(['/felt']);
  }
  
  close(){
    this.logService.canAccessMindLogRegister.set(false);
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    this.router.navigate(['/home'], { replaceUrl: true });
  }

  onSliderChange(event: any){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
  }

}
